/* Energy Unleashed — menu drawer behaviour.
   Open/close, focus trap, scroll-lock and the hamburger→× swap are Horizon's
   (header-drawer.js). This adds only: the Shop by Brand accordion, and a
   swipe-left-to-close gesture on the panel. Event delegation on document so it
   survives Section Rendering hydration morphs. */

const ACC_BTN = '.eum-drawer .eum-acc__btn';

function setExpanded(btn, open) {
  btn.setAttribute('aria-expanded', String(open));
  const panel = btn.nextElementSibling;
  if (panel) panel.toggleAttribute('inert', !open);
}

// initial inert state for collapsed panels (also re-applied after hydration)
function syncPanels(root = document) {
  root.querySelectorAll(ACC_BTN).forEach((btn) => setExpanded(btn, btn.getAttribute('aria-expanded') === 'true'));
}
syncPanels();
new MutationObserver(() => syncPanels()).observe(document.documentElement, { childList: true, subtree: true });

document.addEventListener('click', (e) => {
  const btn = e.target instanceof Element ? e.target.closest(ACC_BTN) : null;
  if (!btn) return;
  const open = btn.getAttribute('aria-expanded') === 'true';
  setExpanded(btn, !open);
  if (!open) {
    // bring the first brand rows into view if the accordion opened below the fold
    requestAnimationFrame(() => btn.scrollIntoView({ block: 'nearest', behavior: 'smooth' }));
  }
});

// swipe left anywhere on the open panel closes it
let sx = null, sy = null;
document.addEventListener('touchstart', (e) => {
  const panel = e.target instanceof Element ? e.target.closest('.menu-drawer.eum-drawer') : null;
  if (!panel) { sx = null; return; }
  sx = e.touches[0].clientX; sy = e.touches[0].clientY;
}, { passive: true });
document.addEventListener('touchend', (e) => {
  if (sx == null) return;
  const dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
  sx = sy = null;
  if (dx < -60 && Math.abs(dy) < 40) {
    const drawer = e.target instanceof Element ? e.target.closest('header-drawer') : null;
    if (drawer && typeof drawer.close === 'function') drawer.close();
  }
}, { passive: true });
